import { useToastContext } from '#pplx/frontend/aether/toasts/context/useToastContext.js';
import { connectorAuthRetrySelectedEvent } from '#pplx/frontend/apps/ask/events/connectors/analytics.js';
import { OAuthIncompleteError } from '#pplx/frontend/apps/ask/oauth-redirect/openRedirectUrl.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export const INSUFFICIENT_SCOPES_ERROR_CODE = 'insufficient_scopes';
const INSUFFICIENT_SCOPES_TOAST_KEY = 'connector-insufficient-scopes';
const INSUFFICIENT_SCOPES_TOAST_TIMEOUT_SECONDS = 8;
/** True when OAuth finished without the access the connector requires. */
export const isInsufficientScopesError = (error) => error instanceof OAuthIncompleteError && error.errorCode === INSUFFICIENT_SCOPES_ERROR_CODE;
/**
 * Explains a rejected partial consent. With `retry`, the toast stays open and offers a Try
 * again action that runs the caller's own connect action.
 */
export function useInsufficientScopesToast() {
    const { openToast } = useToastContext();
    const { $t } = useIntl();
    const { track } = useInstrumentation();
    return useCallback(({ connectorName, retry }) => {
        const message = $t({
            defaultMessage: "Google didn't give Perplexity the access it needs.",
            description: 'Toast error message shown when a user connects a Google connector but leaves required permission checkboxes unticked on the Google consent screen',
            id: '4db15105aa',
        });
        const description = $t({
            defaultMessage: "Connect again and tick every box on Google's screen.",
            description: 'Toast description telling the user how to finish connecting a Google connector after required permissions were not granted',
            id: 'c89d66e5b9',
        });
        if (!retry) {
            // An open toast with this key may carry another attempt's retry; clear it.
            openToast({
                message,
                messageLineClamp: 3,
                description,
                descriptionLineClamp: 3,
                variant: 'error',
                timeoutSeconds: INSUFFICIENT_SCOPES_TOAST_TIMEOUT_SECONDS,
                dedupKey: INSUFFICIENT_SCOPES_TOAST_KEY,
                ctaText: undefined,
                ctaOnClick: undefined,
            });
            return;
        }
        openToast({
            message,
            messageLineClamp: 3,
            description,
            descriptionLineClamp: 3,
            variant: 'error',
            timeoutSeconds: null,
            dedupKey: INSUFFICIENT_SCOPES_TOAST_KEY,
            ctaText: $t({
                defaultMessage: 'Try again',
                description: 'Toast button that restarts a Google connector connection after required permissions were not granted',
                id: 'd59401f920',
            }),
            ctaOnClick: () => {
                track(connectorAuthRetrySelectedEvent({
                    name: 'connector auth retry selected',
                    data: { connectorName, surface: retry.surface, reason: 'insufficient_scopes' },
                }));
                retry.run();
            },
        });
    }, [$t, openToast, track]);
}
//# sourceMappingURL=useInsufficientScopesToast.js.map